import { apiClient } from '../utils/apiClient';

export const ProfileService = {
  async getProfile(accessToken) {
    const token = accessToken || localStorage.getItem('llap_access_token') || localStorage.getItem('llap_auth_token');
    
    if (!token) {
      return { success: false, status: 401, error: 'No access token available.' };
    }

    try {
      const response = await apiClient.get('/.netlify/functions/get-profile', {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response && response.success) {
        return response;
      }

      return { success: false, status: response.status || 401, error: response.error || 'Profile fetch failed.' };
    } catch (error) {
      console.warn('ProfileService error:', error.message);
      const localUser = JSON.parse(localStorage.getItem('user') || 'null');
      if (localUser) {
        return { success: true, profile: localUser };
      }
      return { success: false, status: error.status || 500, error: error.message };
    }
  }
};

export default ProfileService;